import { Injectable, Injector } from "@angular/core";
import { SdkBase } from "@utilities/sdk-base/sdk.base";
import { Observable } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class EmailVerificatoinSdk extends SdkBase {
	constructor(injector: Injector) {
		super(injector);
	}

	public requestVerificationCode(sharedId: string, body: SharedExportRequestVerificationCodeRequest): Observable<any> {
		return this.makeHttpRequest<SharedExportRequestVerificationCodeRequest>('post', `api2/downloads/shared-productions/${sharedId}/request`, body);
	}

    public verifyCode(sharedId: string, body: SharedExportVerifyCodeRequest): Observable<any> {
		return this.makeHttpRequest<SharedExportVerifyCodeRequest>('post', `api2/downloads/shared-productions/${sharedId}/verify`, body);
	}
}


class SharedExportRequestVerificationCodeRequest
{
	caseId: string;
    productionJobId: string; 
    email: string;
}

class SharedExportVerifyCodeRequest
{
    productionJobId: string;
    caseId: string;
    email: string;
    verificationCode: string;
}